import { snowtrade } from "../../../../api";

export const sendAcceptChangeRequestsRequest = (optionId) =>
  snowtrade.patch(`/api/sales/leads/${optionId}/change-request/accept`);

export const sendDeclineChangeRequestsRequest = (optionId) =>
  snowtrade.patch(`/api/sales/leads/${optionId}/change-request/decline`);
